const day2Millis = 86400 * 1000;
const millis2Day = 1 / day2Millis;
const mjd2000Unix = 946684800 * 1000;
export function mjd2unix(mjd) {
    return mjd * day2Millis + mjd2000Unix;
}
export function unix2mjd(unix) {
    return (unix - mjd2000Unix) * millis2Day;
}
//# sourceMappingURL=timeParser.js.map